<div
  *appHasAccess="['ROLES_VIEW']"
  class="role-list">
  <button
    *appHasAccess="['ROLES_ADD']"
    (click)="addRole()"
    class="btn btn-accent icon">
    <img
      src="assets/img/plus-icon.svg"
      alt="Plus"
      class="icon-button" />
    {{ "ROLE_PAGE.ADD" | translate }}
  </button>

  <div class="role-list__cards">
    <div
      *ngFor="let item of roleList; let i = index"
      (click)="editRole(item.id)"
      class="role-list__cards-item">
      <app-role-item
        [index]="i"
        [roleItem]="item"
        (isOpenModalDeleteRole)="openDeleteModal(item)">
      </app-role-item>
    </div>
  </div>
</div>

<app-modal [(isOpenModal)]="isOpenModalDeleteRole">
  <app-delete-role-dialog
    [item]="currentRole"
    (deleteRole)="deleteRole($event)">
  </app-delete-role-dialog>
</app-modal>

<app-modal
  [(isOpenModal)]="isOpenModalAddRole"
  [isFull]="true">
  <app-add-role-dialog
    *ngIf="isOpenModalAddRole"
    (roleAdded)="addedRole()"></app-add-role-dialog>
</app-modal>

<app-modal
  [(isOpenModal)]="isOpenModalEditRole"
  [isFull]="true">
  <app-edit-role-dialog
    *ngIf="isOpenModalEditRole"
    [roleDetail$]="roleDetail"
    (roleEditSuccess)="editingRole()">
  </app-edit-role-dialog>
</app-modal>
